import { MERCHANT_ORGANIZATION } from "constants/action-types";

export const fetchMerchantOrganization = (merchantId: string) => ({
    type: MERCHANT_ORGANIZATION.FETCH.START,
    payload: { merchantId: merchantId },
});
